<template>
  <div
    class="prbg-white prrounded prborder p-3"
    v-if="auth.token && auth.login"
  >
    <div class="col-12 col-md-12" style="width: 100%">
      <div class="card-header">
        <ul
          class="nav nav-tabs card-header-tabs"
          role="tablist"
          style="flex-wrap: nowrap !important"
        >
          <li class="nav-item w-33">
            <a
              class="nav-link w-100"
              @click="flagFlag('one')"
              style="width: max-content"
              aria-controls="first"
              aria-selected="true"
              >تراکنش ها</a
            >
          </li>
          <li class="nav-item w-33">
            <a
              class="nav-link w-100"
              @click="flagFlag('two')"
              style="width: max-content"
              aria-controls="two"
              aria-selected="true"
              >درخواست برداشت ها</a
            >
          </li>
          <li class="nav-item w-33">
            <a
              class="nav-link w-100"
              @click="flagFlag('three')"
              style="width: max-content"
              aria-controls="three"
              aria-selected="true"
              >شارژ و اینترنت</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div
            class="tab-pane fade overflow-auto"
            :class="{ 'active show': flag.one }"
            id="first"
            role="tabpanel"
            aria-labelledby="first-tab"
          >
            <div
              class="alert alert-warning my-1 border-0 prfont-weight text-center w-100"
              role="alert"
            >
              مجموع تراکنش های شما
              {{ convertToPersian(String(sumTransaction)) }} تومان است.
            </div>
            <div class="float-md-right d-flex align-items-center w-50 my-2">
              <span class="text-muted text-small">نمایش</span>
              <select
                class="form-control rounded"
                v-model="tranType"
                @change="getTransaction"
              >
                <option value="all">همه</option>
                <option
                  v-for="(item, index) in transactionTypes"
                  :key="index"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </div>
            <table
              class="mt-2 table table-hover table-bordered table-striped"
              id="orderTable"
            >
              <thead>
                <tr>
                  <th scope="col">شماره تراکنش</th>
                  <th scope="col">نوع تراکنش</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">مبلغ کل (تومان)</th>
                  <th scope="col">توضیحات</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in transactionList"
                  :key="item.id"
                  :data-id="item.id"
                >
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ convertToPersian(String(item.amount)) }}</td>
                  <td style="max-width:300px">{{ item.description }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="tab-pane fade overflow-auto"
            :class="{ 'active show': flag.two }"
            id="two"
            role="tabpanel"
            aria-labelledby="two-tab"
          >
            <table
              class="mt-2 table table-hover table-bordered table-striped"
              id="orderTable"
            >
              <thead>
                <tr>
                  <th scope="col">شماره استرداد</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">وضعیت</th>
                  <th scope="col">مبلغ کل (تومان)</th>
                  <th scope="col">توضیحات</th>
                  <th scope="col">رسید</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in refundList"
                  :key="item.id"
                  :data-id="item.id"
                >
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.date }}</td>
                  <td>
                    {{
                      item.state == 1
                        ? "در حال بررسی"
                        : 2
                        ? "تایید شده"
                        : "رد شده"
                    }}
                  </td>
                  <td>{{ convertToPersian(String(item.amount)) }}</td>
                  <td>
                    <span v-if="item.code"
                      >کد پیگیری :
                      {{ convertToPersian(String(item.code)) }}</span
                    ><br v-if="item.code" />
                    {{ item.description }}
                  </td>
                  <td>
                    <a
                      v-if="item.file"
                      :href="'https://radap.ir/' + item.file"
                      target="_blank"
                      class="text-dark"
                      ><i class="bi bi-eye"></i
                    ></a>
                    <i v-else class="bi  bi-x"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="tab-pane fade overflow-auto"
            :class="{ 'active show': flag.three }"
            id="three"
            role="tabpanel"
            aria-labelledby="three-tab"
          >
            <div
              class="alert alert-warning my-1 border-0 prfont-weight text-center w-100"
              role="alert"
              v-if="showCard == 'month'"
            >
              شما در این ماه {{ convertToPersian(String(countCard)) }} بار و
              مجموع {{ convertToPersian(String(sumCard)) }} تومان از راداَپ شارژ
              و اینترنت خریده اید.
            </div>
            <div
              class="alert alert-warning my-1 border-0 prfont-weight text-center w-100"
              role="alert"
              v-else
            >
              شما تا این لحظه {{ convertToPersian(String(countCard)) }} بار و
              مجموع {{ convertToPersian(String(sumCard)) }} تومان از راداَپ شارژ
              و اینترنت خریده اید.
            </div>
            <table class="mt-2 table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col">شماره سفارش</th>
                  <th scope="col">تراکنش</th>
                  <th scope="col">اپراتور</th>
                  <th scope="col">موبایل</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">مبلغ (تومان)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in cardItems" :key="item.id" :data-id="item.id">
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>
                    {{ item.type }}
                    <span v-if="item.name">({{ item.name }})</span>
                  </td>
                  <td>
                    {{
                      item.operator == "MTN"
                        ? "ایرانسل"
                        : "MCI"
                        ? "همراه اول"
                        : "رایتل"
                    }}
                  </td>
                  <td>{{ convertToPersian(String(item.mobile)) }}</td>
                  <td>{{ item.time }}</td>
                  <td>{{ convertToPersian(String(item.amount)) }}</td>
                </tr>
                <tr v-if="showCard == 'month'">
                  <td
                    colspan="6"
                    class="text-center"
                    @click="(showCard = 'all'), getCarding()"
                  >
                    <i class="bi bi-chevron-down"></i> نمایش همه
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-danger" v-else>شمامجوز دسترسی به این صفحه را ندارید</div>
</template>

<script setup>
import { ref, reactive } from "@vue/reactivity";
import { convertToPersian } from "@/composables/digits";
import { useAuth } from "@/store/auth";
let auth = useAuth();
let transactionList = ref();
let tranType = ref("all");
let transactionTypes = ref();
let sumTransaction = ref("");
let refundList = ref();
let countCard = ref();
let sumCard = ref();
let cardItems = ref();
let showCard = ref("month");
let flag = reactive({
  one: true,
  two: false,
  three: false,
});
auth.getToken();
getTransaction();
getRefundTransaction();
getCarding();
async function getTransaction() {
  const formdata = new FormData();
  formdata.append("token", auth.token);
  formdata.append("type", 2);
  formdata.append("transaction", tranType.value);
  let response = await fetch(
    "https://radap.ir/Backend/api/account/transaction/get.php",
    {
      method: "POST",
      body: formdata,
    }
  );
  let data = await response.json();
  transactionList.value = data.data;
  transactionTypes.value = data.types;
  sumTransaction.value = data.sum;
}
async function getRefundTransaction() {
  const formdata = new FormData();
  formdata.append("token", auth.token);
  let response = await fetch(
    "https://radap.ir/Backend/api/account/transaction/refund.php",
    {
      method: "POST",
      body: formdata,
    }
  );
  let data = await response.json();
  refundList.value = data.data;
}
async function getCarding() {
  const formdata = new FormData();
  formdata.append("token", auth.token);
  formdata.append("show", showCard.value);
  let response = await fetch(
    "https://radap.ir/Backend/api/account/order/cards.php",
    {
      method: "POST",
      body: formdata,
    }
  );
  let data = await response.json();
  cardItems.value = data.data;
  countCard.value = data.count;
  sumCard.value = data.sum;
}
function flagFlag(num) {
  flag.one = false;
  flag.two = false;
  flag.three = false;
  if (num == "one") {
    flag.one = true;
  } else if (num == "two") {
    flag.two = true;
  } else if (num == "three") {
    flag.three = true;
  }
}
</script>

<style scoped>
/* @import "../../../../assets/css/account.css"; */

table thead tr th {
  text-align: right;
}
</style>
